import React from 'react';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  rootAppBar: {
    flexGrow: 1
  },
  appBar: {
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 2px 6px 0 hsla(0,0%,81%,.47)'
  },
  linkToolbar: {
    height: '41.6%',
    backgroundSize: '90px',
    backgroundImage: 'url(/online-pajak.svg)',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '220px',
    backgroundPosition: '1%',
    lineHeight: '66px',
    textDecoration: 'none',
    display: 'flex',
    borderRight: '1px solid #ebebeb'
  },
  leftWrapper: {
    paddingLeft: '24px'
  },
  appName: {
    backgroundColor: theme.palette.primary.main,
    fontWeight: 'bold',
    paddingLeft: '1em',
    paddingRight: '1em',
    lineHeight: '66px'
  }
}));

function VendorAppBar() {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <AppBar className={classes.appBar} position="fixed">
      <div className={classes.leftWrapper}>
        <div className={classes.linkToolbar} data-testid="logo">
          <Typography variant="h6" className={classes.appName}>VENDOR PORTAL APP</Typography>
        </div>
      </div>
    </AppBar>
  );
}

export default VendorAppBar;
